import styled from 'styled-components';

const IconWrapper = styled.div`
  display: flex;
`;

export default IconWrapper;
